/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridFilterItem } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';
import {
 Dispatch,
 MutableRefObject,
 SetStateAction,
 useEffect,
 useMemo,
} from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';

import { usePage } from '../../../contexts/usePageContext';
import { setConfigStorageItem } from '../../../hooks/useConfigStorage';
import { changeCurrentPreset } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { getBaseDomain } from '../../../redux/pageDomain';
import { RootState } from '../../../redux/store';
import { findStructure, getTranslation } from '../../../utils/dataTypes';
import { CustomGridApi } from '../XTable/types';
import { updateUrlFilterParams } from '../XTable/urlFilterParams';

const useFilterMenu = ({
 filterMenuState,
 apiRef,
 setOpen,
}: {
 filterMenuState: {
  anchorElement: HTMLDivElement | HTMLButtonElement | null;
  colName: string;
 } | null;
 apiRef: MutableRefObject<CustomGridApi>;
 setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
 const { pageName } = usePage();
 const dispatch = useDispatch();
 const colName = filterMenuState?.colName || 'error!';
 const anchorElement = filterMenuState?.anchorElement;
 const currentColumnsPreset = useSelector(
  (state: RootState) =>
   state.clientConfiguration.currentColumnsPreset?.[pageName] || null,
 );

 const structure = useSelector(
  (state: RootState) => (state[getBaseDomain(pageName)] as any).structure,
 );

 const currentStructure = useMemo(
  () => findStructure(structure, colName),
  [structure, colName],
 );

 const currentType = currentStructure?.Type;

 const methods = useForm<Record<string, any>>({
  mode: 'onChange',
  defaultValues: { [colName]: '' },
 });

 const {
  control,
  formState: { errors },
  reset,
  watch,
  formState,
  setValue,
  getValues,
 } = methods;

 const handleSave = (formData: any) => {
  setOpen(false);
 };

 const handleChange = (name: string, value: any) => {
  let newItems = [] as GridFilterItem[];
  const currentItems = apiRef.current.state.filter.filterModel.items;
  const isDateTime = ['DateFrom', 'DateTo'].includes(name);
  console.log('handleChange', name, value, isDateTime, currentItems);
  if (isDateTime) {
   if (currentItems.length) {
    newItems = currentItems.filter((item) => item.field !== colName);

    if (name === 'DateFrom') {
     console.log(1);
     const dateFilters = [];
     dateFilters.push({
      id: `${colName}_${Math.random()}`,
      field: colName,
      value: dayjs(value).format('YYYY-MM-DDTHH:mm:ss.SSS'),
      operator: 'onOrAfter',
     });
     if (getValues('DateTo') !== '') {
      console.log(2);
      dateFilters.push({
       id: `${colName}_${Math.random()}`,
       field: colName,
       value: dayjs(getValues('DateTo')).format('YYYY-MM-DDTHH:mm:ss.SSS'),
       operator: 'onOrBefore',
      });
     }
     newItems = [...newItems, ...dateFilters];
    } else if (name === 'DateTo') {
     console.log(3);
     const dateFilters = [];
     dateFilters.push({
      id: `${colName}_${Math.random()}`,
      field: colName,
      value: dayjs(value).format('YYYY-MM-DDTHH:mm:ss.SSS'),
      operator: 'onOrBefore',
     });
     if (getValues('DateFrom') !== '') {
      console.log(4);
      dateFilters.unshift({
       id: `${colName}_${Math.random()}`,
       field: colName,
       value: dayjs(getValues('DateFrom')).format('YYYY-MM-DDTHH:mm:ss.SSS'),
       operator: 'onOrAfter',
      });
     }
     newItems = [...newItems, ...dateFilters];
    }

    newItems = newItems.filter((item) => item.value !== 'Invalid Date'); // bad practice
   } else {
    console.log(5);
    newItems = [
     {
      id: `${colName}_${Math.random()}`,
      field: colName,
      value: dayjs(value).format('YYYY-MM-DDTHH:mm:ss.SSS'),
      operator: name === 'DateFrom' ? 'onOrAfter' : 'onOrBefore',
     },
    ];
   }
  } else if (currentItems.some((item) => item.field === colName)) {
   console.log('if this filter is already in filterModel');
   newItems = currentItems
    .map((item) => {
     let newValue = value;
     if (isDateTime) {
      console.log('isDateTime', getValues('DateFrom'), getValues('DateTo'));
      newValue = `${dayjs(getValues('DateFrom')).format('YYYY.MM.DD HH:mm:ss')}-${dayjs(getValues('DateTo')).format('YYYY.MM.DD HH:mm:ss')}`;
     } else if (newValue?.Id) {
      newValue = newValue?.Id;
     }
     return item.field === colName ? { ...item, value: newValue } : item;
    })
    .filter((item) => {
     if (item.value === '' || item.value === undefined || item.value === null)
      return false;
     if (Array.isArray(item.value)) return item.value.length !== 0;
     return true;
    });
  } else {
   console.log('this filter is not in filterModel, why?', colName, value);
   const defaultOperator =
    currentStructure?.Type === 'string' ? 'contains' : 'equals';
   newItems = [
    ...currentItems,
    {
     id: `${colName}_${value[0]?.Id ? value?.map((item: any) => item.Id).join('_') : value}`,
     field: colName,
     value: value[0]?.Id ? value?.map((item: any) => item.Id) : value,
     operator: defaultOperator,
    },
   ];
  }

  apiRef.current.setFilterModel(
   {
    ...apiRef.current.state.filter.filterModel,
    items: newItems,
   },
   'upsertFilterItems',
  );
  // ???
  setValue(colName, value);

  let dateString = '';
  const fromValue = name === 'DateFrom' ? value : dayjs(getValues('DateFrom'));
  const toValue = name === 'DateTo' ? value : dayjs(getValues('DateTo'));

  // what about empty values??
  if (dayjs(fromValue).isValid()) {
   dateString = dayjs(fromValue).format('YYYY.MM.DD HH:mm:ss');
  } else {
   dateString = 'x';
  }

  if (dayjs(toValue).isValid()) {
   dateString = `${dateString}-${dayjs(toValue).format('YYYY.MM.DD HH:mm:ss')}`;
  } else {
   dateString = `${dateString}-x`;
  }

  console.log('colName', colName, value, dateString);

  const isEmptyValue =
   value === '' || (Array.isArray(value) && value.length === 0);

  const preset = {
   ...currentColumnsPreset,
   name: currentColumnsPreset?.name || '',
   columns: currentColumnsPreset?.columns || [],
   filters: {
    fields: Object.keys({
     ...currentColumnsPreset?.filters?.fields,
     [colName]: isDateTime ? dateString : value,
    })
     .sort((a, b) => {
      const aIndex =
       currentColumnsPreset?.columns.findIndex((col) => col.field === a) || 0;
      const bIndex =
       currentColumnsPreset?.columns.findIndex((col) => col.field === b) || 0;
      return aIndex - bIndex;
     })
     .reduce(
      (acc, key) => {
       acc[key] =
        key === colName
         ? isDateTime
           ? dateString
           : value
         : currentColumnsPreset?.filters?.fields?.[key] || '';
       return acc;
      },
      {} as Record<string, any>,
     ),
    operators: Object.keys(currentColumnsPreset?.filters?.operators || {})
     .sort((a, b) => {
      const aIndex =
       currentColumnsPreset?.columns.findIndex((col) => col.field === a) || 0;
      const bIndex =
       currentColumnsPreset?.columns.findIndex((col) => col.field === b) || 0;
      return aIndex - bIndex;
     })
     .reduce(
      (acc, key) => {
       acc[key] = isEmptyValue
        ? ''
        : key === colName
          ? currentColumnsPreset?.filters?.operators?.[key] || 'equals'
          : '';
       return acc;
      },
      {} as Record<string, string>,
     ),
   },
  };

  console.log(
   'HANDLECHANGE ',
   isEmptyValue,
   {
    operators: currentColumnsPreset?.filters?.operators,
    colName,
    newItems,
    preset,
   },
   Array.isArray(value) && value.length === 0,
  );

  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset,
    temp: true,
   }),
  );
  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset,
    temp: false,
   }),
  );
  setConfigStorageItem({
   page: pageName,
   key: 'columns',
   value: preset,
  });

  updateUrlFilterParams(preset.filters ?? null);
 };

 const handleDelete = () => {
  apiRef.current.setFilterModel(
   {
    ...apiRef.current.state.filter.filterModel,
    items: apiRef.current.state.filter.filterModel.items.filter(
     (item) => item.field !== colName,
    ),
   },
   'upsertFilterItems',
  );

  const preset = {
   ...currentColumnsPreset,
   name: currentColumnsPreset?.name || '',
   columns: currentColumnsPreset?.columns || [],
   filters: {
    fields: {
     ...currentColumnsPreset?.filters?.fields,
     [colName]: '',
    },
    operators: {
     ...currentColumnsPreset?.filters?.operators,
     [colName]: '',
    },
   },
  };
  console.log('pppppppreset', preset);

  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset,
    temp: true,
   }),
  );

  dispatch(
   changeCurrentPreset({
    page: pageName,
    type: 'columns',
    preset,
    temp: false,
   }),
  );

  setConfigStorageItem({
   page: pageName,
   key: 'columns',
   value: preset,
  });

  const allEmpty = Object.values(preset.filters?.fields ?? {}).every(
   (v) => !v || (Array.isArray(v) && !(v as unknown[]).length),
  );
  updateUrlFilterParams(allEmpty ? null : preset.filters ?? null);

  setTimeout(() => {
   setOpen(false);
  }, 300);
 };

 const currentFilter = useMemo(
  () =>
   apiRef.current.state.filter.filterModel.items.find(
    (item) => item.field === colName,
   ),
  [apiRef, colName],
 );

 const getValuesFromStorage = () => {
  // if (!Object.keys(currentColumnsPreset || {}).length || !structure)
  //  return false;

  const fieldsWithoutDates = Object.keys(
   currentColumnsPreset?.filters?.fields || {},
  )
   .filter((key) => findStructure(structure, key)?.Type !== 'datetime')
   .reduce(
    (acc, key) => ({
     ...acc,
     [key]: currentColumnsPreset?.filters?.fields[key] || '',
    }),
    {},
   ); // to replace null values with ''

  const dateFields = Object.entries(
   currentColumnsPreset?.filters?.fields || {},
  ).filter(
   ([key, value]) => findStructure(structure, key)?.Type === 'datetime',
  );

  //   console.log('dateFields', dateFields, currentColumnsPreset?.filters?.fields);

  let dateFieldsObject = {};
  if (
   dateFields[0] &&
   typeof currentColumnsPreset?.filters?.fields[dateFields[0][0]] === 'string'
  ) {
   const dateString = currentColumnsPreset?.filters?.fields[dateFields[0][0]];
   //    console.log('dateString', dateString);
   if (typeof dateString === 'string') {
    const dateArray = dateString.split('-');
    // console.log('dateArray', dateArray);
    if (dayjs(dateArray[0]).isValid()) {
     dateFieldsObject = {
      ...dateFieldsObject,
      DateFrom: dateArray[0],
     };
    } else if (dateArray[0] === 'x') {
     dateFieldsObject = {
      ...dateFieldsObject,
      DateFrom: '',
     };
    }
    if (dayjs(dateArray[1]).isValid()) {
     dateFieldsObject = {
      ...dateFieldsObject,
      DateTo: dateArray[1],
     };
    } else if (dateArray[1] === 'x') {
     dateFieldsObject = {
      ...dateFieldsObject,
      DateTo: '',
     };
    }
   }
  }

  const output = {
   ...fieldsWithoutDates,
   ...dateFieldsObject,
   operators: currentColumnsPreset?.filters?.operators,
  };
  return output;
 };

 useEffect(() => {
  const vals = getValuesFromStorage();
  reset(vals);
 }, [currentColumnsPreset]);

 return {
  handleSave,
  handleChange,
  handleDelete,
  translation: getTranslation(structure, colName),
  currentFilter,
  currentType,
  currentStructure,
  control,
  formState,
  errors,
  watch,
  setValue,
  methods,
  anchorElement,
  getValues,
  colName,
 };
};

export default useFilterMenu;
